import { render, staticRenderFns } from "./basicFacts.vue?vue&type=template&id=8d57edac&scoped=true"
import script from "./basicFacts.vue?vue&type=script&lang=js"
export * from "./basicFacts.vue?vue&type=script&lang=js"
import style0 from "./basicFacts.vue?vue&type=style&index=0&id=8d57edac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d57edac",
  null
  
)

export default component.exports